import type { CanvasKeyDownHandler } from '../Shared/Canvas'

type JustTheFactsRoot = {
  gameStage?: createjs.DisplayObject & { startButton?: createjs.DisplayObject }
}

const START_KEYS = new Set(['Enter', ' '])

export const startOnKeyDown: CanvasKeyDownHandler = (event, exportRoot) => {
  if (!START_KEYS.has(event.key) || event.repeat) return
  const startButton = getActivatableStartButton(exportRoot)
  if (!startButton) return

  event.preventDefault()
  // Clicking Start installs the game's document key handler synchronously; keep this key from reaching it as an empty answer.
  event.stopPropagation()
  startButton.dispatchEvent(new createjs.Event('click', false, false))
}

function getActivatableStartButton(
  exportRoot: createjs.DisplayObject
): createjs.DisplayObject | null {
  const { gameStage } = exportRoot as JustTheFactsRoot
  const startButton = gameStage?.startButton
  if (!gameStage?.visible || !startButton?.visible) return null
  return startButton.mouseEnabled ? startButton : null
}
